import React, { Fragment } from 'react';
import { func, string, bool, object, element } from 'prop-types';

import { Modal, Button, SnapaskLoader } from '@snapask/common-components';
import gray from '@snapask/common-components/styles/buttonTheme/gray.scss';

import styles from './Dialog.scss';
import modalTheme from './modalTheme.scss';
const cx = require('classnames/bind').bind(styles);

function Dialog({
  confirmText,
  onConfirm,
  closeText,
  onClose = () => {},
  title,
  content,
  contentSetInnerHTML,
  rightContent,
  isLoading = false,
  theme = {},
}) {
  return (
    <Modal theme={modalTheme} onClose={onClose}>
      <div className={styles.root}>
        {isLoading ? (
          <SnapaskLoader />
        ) : (
          <Fragment>
            <div className={cx(styles.content, theme.content)}>
              <div>
                <h5>{title}</h5>
                <p dangerouslySetInnerHTML={contentSetInnerHTML}>{content}</p>
              </div>
              {rightContent && <div>{rightContent}</div>}
            </div>
            <div className={styles.buttons}>
              {closeText && (
                <Button ghost theme={gray} text={closeText} onClick={onClose} />
              )}
              <Button
                theme={theme.confirmButton}
                text={confirmText}
                onClick={onConfirm}
              />
            </div>
          </Fragment>
        )}
      </div>
    </Modal>
  );
}

Dialog.propTypes = {
  confirmText: string.isRequired,
  title: string.isRequired,
  onConfirm: func.isRequired,
  closeText: string,
  content: string,
  contentSetInnerHTML: object,
  isLoading: bool,
  rightContent: element,
  theme: object,
  onClose: func,
};

export default Dialog;



// WEBPACK FOOTER //
// ./app/components/Dialog/Dialog.jsx